module.exports = __webpack_public_path__ + "img/molluscs.cef061fd.png";